<template>
    <div class="dynamic-pricing-rule-component">
        <div :class="loadMask"></div>
        <div>
            <div class="row" v-if="errors.message">
                <div class="col-lg-12">
                    <span class="error">{{ t(errors.message) }}</span>
                </div>
            </div>

            <!-- Selection section -->
            <div class="row">
              <div class="col-lg-12">
                <label>{{ t('Selected products') }}</label>
                <ul>
                  <li>Wybrano {{ getSelected }} z {{ getTotalRows }} produkt/ów</li>
                </ul>
                <span v-if="hasError('selectedRows')" class="error">{{ t(errors.selectedRows) }}</span>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-12">
                <p>{{ t('Changes made in the dashboard do not affect the rules in the source from which you provide us with data. If you revert to automatic rule management, please ensure that the source contains the appropriate rule tags.') }}</p>
              </div>
            </div>

            <!-- Price rule section -->

            <div class="row">
              <div class="col-lg-6 form-group">
                <label>{{ t('Set auto accept') }}</label>
                <multiselect
                    :placeholder="t('Select')"
                    :options="availableAutoAcceptOptions"
                    :multiple="false"
                    :close-on-select="true"
                    :clear-on-select="false"
                    track-by="id"
                    label="name"
                    :loading="false"
                    v-model="inputs.autoAccept"
                >
                  <div slot="noOptions">{{ t('List is empty') }}</div>
                </multiselect>
              </div>
              <div class="clearfix"></div>
              <div class="col-lg-6 form-group">
                <span v-if="hasError('autoAccept')" class="error">{{ t(errors.autoAccept) }}</span>
              </div>
            </div>
            <!-- end Price rule section -->

            <div class="row">
                <div class="col-lg-12">
                    <button class="btn btn-success btn-confirm"
                            @click.prevent="submit"
                    >{{ t('Submit') }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import State from "@/Models/State.ts";
import ValueChecker from "@/services/ValueChecker";
import Multiselect from "@/components/Multiselect.vue";

export default {
    components: {
      Multiselect
    },
    props: {
        config: {
            Type: Object
        },
        eventData: {
            Type: Object
        },
        eventBus: {
            type: Object,
        },
    },
    data: function () {
        return {
            loadMask: '',
            availableAutoAcceptOptions: [],
            inputs: {
                autoAccept: null
            },
            errors: {},
            events: [],
            stateOrigin: new State()
        };
    },
    beforeDestroy() {
    },
    async mounted() {
        this.init();
        this.stateOrigin.value = this.inputs;
    },
    computed: {
        getSelected() {
          return this.$store.getters.getRecordsNumberForSelections('DynamicPricingGridComponent');
        },
        getTotalRows() {
          return this.$store.getters.getTotalRecordsNumberForSelections('DynamicPricingGridComponent');
        }
    },
    methods: {
        init() {
            let selection = this.$store.getters.getSelection('DynamicPricingGridComponent');

            this.availableAutoAcceptOptions = [
                {'id': true, 'name': this.$translate.text('Set Yes')},
                {'id': false, 'name': this.$translate.text('Set No')},
            ];

            this.inputs.selected = selection.selected;
            this.inputs.excluded = selection.excluded;
            this.inputs.allSelected = selection.allSelected;
            this.inputs.filters = selection.filters;
        },
        async submit() {
            this.addLoadMask();

            if (!await this.validate()) {
                this.removeLoadMask();

                return;
            }

            let formData = this.getFormData();
            let url = this.getSubmitUrl();
            let response;
            let params = {};

            try {
                response = await this.$http['post'](url, formData, params);
                this.stateOrigin.resetState(this.inputs);
                let eventManagerService = this.eventBus.getEventManager();
                let afterSubmitEvents = this.config.emitEvents['afterSubmit'];

                if (afterSubmitEvents) {
                    eventManagerService.emitEvents(afterSubmitEvents, [{
                        eventData: this.eventData
                    }]);
                }
            } catch (error) {
                this.addError('message', error.data.message);
            } finally {
                this.removeLoadMask();
            }
        },
        async validate() {
            for (let member in this.errors) delete this.errors[member];

            if (!this.inputs.allSelected && 0 === this.inputs.selected.length) {
                this.addError('selectedRows', 'Please select at least one product');
            }

            if (null === this.inputs.autoAccept || ValueChecker.isUndefinedOrNull(this.inputs.autoAccept.id)) {
              this.addRequiredError('autoAccept');
            }

            return 0 === Object.keys(this.errors).length;
        },
        getFormData() {
            return {
              autoAccept: this.inputs.autoAccept.id,
              allSelected: this.inputs.allSelected,
              selected: this.inputs.selected,
              excluded: this.inputs.excluded,
              filters: this.inputs.filters,
            };
        },
        addLoadMask() {
            this.loadMask = 'lmask';
        },
        removeLoadMask() {
            this.loadMask = '';
        },
        addRequiredError(key) {
            this.addError(key, this.$trans('This field is required'));
        },
        addError(key, value) {
            this.$set(this.errors, key, value);
        },
        hasError(key) {
            return key in this.errors;
        },
        getSubmitUrl() {
            return this.config['editUrl'];
        },
        async canCloseModal() {
            if (!this.stateOrigin.isEqual(this.inputs)) {
                return await this.hasInputsChange();
            }

            return true;
        },
        hasInputsChange() {
            return new Promise((resolve) => {
                this.$root.showConfirmModalResolve('Confirm?', resolve);
            });
        }
    }
};
</script>

<style scoped>
.dynamic-pricing-rule-component {
    flex: 1;
}

input[type=checkbox], input[type=radio] {
    margin: 4px 0 0;
    margin-top: 1px \9;
    line-height: normal;
    box-shadow: none;
}

input[type=number] {
    box-shadow: none;
    border-radius: 5px;
}

.error {
    color: red;
}

</style>



// WEBPACK FOOTER //
// DynamicPricingProductSetAutoAcceptComponent.vue?640e70ad